import { useState } from "react";
import FaqModal from "../FaqModal/FaqModal";
import styles from "./HelpSupport.module.scss";

const RSVP_EMAIL = "contato@desfiopes2026.com.br";
const RSVP_PHONE_LABEL = "(11) 91906-6565";
const RSVP_WHATSAPP_URL = "https://wa.me/5511919066565";

function HelpSupport({ showContact = false }) {
  const [isFaqOpen, setIsFaqOpen] = useState(false);

  return (
    <aside className={`${styles.support} ${showContact ? styles.withContact : ""}`} aria-label="Ajuda e contato">
      <button className={styles.faqTrigger} type="button" onClick={() => setIsFaqOpen(true)}>
        Ver FAQ
      </button>

      {showContact ? (
        <div className={styles.contact}>
          <strong>Contato RSVP</strong>
          <span>E-mail: <a href={`mailto:${RSVP_EMAIL}`}>{RSVP_EMAIL}</a></span>
          <span>WhatsApp: <a href={RSVP_WHATSAPP_URL} target="_blank" rel="noreferrer">{RSVP_PHONE_LABEL}</a></span>
        </div>
      ) : null}

      {isFaqOpen ? <FaqModal onClose={() => setIsFaqOpen(false)} /> : null}
    </aside>
  );
}

export default HelpSupport;
